import { forwardRef } from 'react'

import { TextField as MuiTextField } from '@mui/material'
import { Controller } from 'react-hook-form'

const TextField = (props: any, ref: any) => {
  const { control, defaultValue = '', helperText = null, name, ...filteredProps } = props || {}
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <MuiTextField
          inputRef={ref}
          name={name}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          {...filteredProps}
          value={value}
          onChange={onChange}
          error={!!error}
          helperText={error ? error.message : helperText}
        />
      )}
    />
  )
}

export default forwardRef(TextField)

const SimpleTextField = forwardRef((props: any, ref: any) => {
  return <MuiTextField inputRef={ref} variant="outlined" InputLabelProps={{ shrink: true }} {...props} />
})

SimpleTextField.displayName = 'SimpleTextField'

export { SimpleTextField }
